module.exports = __webpack_public_path__ + "static/media/panico.97b9c38d.png";